import styles from "./username-field.module.css";

import { useTranslation } from "react-i18next";
import { KeyboardEvent } from "react";
import { InputField } from "../../../../components/form/input-field";

export interface UsernameFieldProps {
  value: string;
  onChange?(value: string, target?: any): void;
  onKeyUpEvent?(e: KeyboardEvent<HTMLInputElement>): void;
}

export function UsernameField(props: UsernameFieldProps) {
  const { t } = useTranslation("login");
  const { value, onChange } = props;

  return (
    <div className={styles["login-username-field"]}>
      <InputField
        placeholder={t("username")}
        onChange={onChange}
        value={value}
        onKeyUpEvent={props.onKeyUpEvent}
      />
    </div>
  );
}
